<template>
    <div id="cartontoCon">
        <a-row>
            <a-button type="primary"   v-for="(item, index) in btnFunArr"  :key="index"   v-if="item.code == 'PTC-NewContainer' && item.arr.length > 0"  size="small" style="margin: 0 10px;" @click="newContainer">{{ item.arr[0].name }}</a-button>
        </a-row>
        <a-divider dashed  style="margin: 10px 0"/>
        <a-row>
            <a-col :span="5" style="border-right: 1px solid #efefef;padding: 10px">
                <a-row type="flex" justify="start">
                    <a-col>
                        <p class="scanCodeTile">{{ fieldMap.ptcLoadedPalletQty.displayName  }}</p>
                        <div class="radiusback" style="background: #00ccff;">
                            <i>{{loadedCartonQtyNum}}</i>
                        </div>
                    </a-col>
                </a-row>
            </a-col>
            <a-col :span="19">
                <a-form :form="form">
                    <a-form-item
                            :label-col="formItemLayout.labelCol"
                            :wrapper-col="formItemLayout.wrapperCol"
                            :label="fieldMap.ptcContainerNo.displayName ">
                        <a-input
                                :placeholder="fieldMap.ptcContainerNo.displayName"
                                v-model="pToCanContainerVal"
                                @pressEnter="pToCanContainerEnter"/>
                    </a-form-item>
                    <a-form-item
                            :label-col="formItemLayout.labelCol"
                            :wrapper-col="formItemLayout.wrapperCol"
                            :label="fieldMap.ptcPalletNo.displayName">
                        <a-input
                                :placeholder="fieldMap.ptcPalletNo.displayName"
                                ref="palletNoTocRef"
                                v-model="pToCanPalletVal"
                                @pressEnter="pToCanPalletEnter"/>
                    </a-form-item>
                    <a-form-item v-bind="tailFormItemLayout">
                        <a-checkbox
                                :checked="removePalletConCked"
                                @change="removePalletToConChange">
                            {{ fieldMap.ptcRmPalletFmContainer.displayName}}
                        </a-checkbox>
                    </a-form-item>
                </a-form>
            </a-col>
        </a-row>
        <a-row>
            <vxe-table
                    border
                    resizable
                    :data.sync="loadingCartontoCanTable"
                    max-height="350"
                    show-footer
                    :footer-method="footerMethod"
                    :footer-cell-class-name="footerCellClassName"
                    size="mini"
            >
                <template v-slot:empty>
                    <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                </template>
                <vxe-table-column
                        width="200"
                        field="relId"
                        :title="fieldMap.ptcRelId.displayName"
                        show-header-overflow="ellipsis" show-overflow="ellipsis"
                >
                </vxe-table-column>
                <vxe-table-column
                        width="200"
                        field="packId"
                        show-header-overflow="ellipsis" show-overflow="ellipsis"
                        :title="fieldMap.ptcPackId.displayName">
                </vxe-table-column>
                <vxe-table-column
                        width="200"
                        show-header-overflow="ellipsis" show-overflow="ellipsis"
                        field="carton"
                        :title="fieldMap.ptcCarton.displayName">
                </vxe-table-column>
                <vxe-table-column
                        width="300"
                        field="sscc"
                        show-header-overflow="ellipsis" show-overflow="ellipsis"
                        :title="fieldMap.ptcTrackingNo.displayName">
                </vxe-table-column>
                <vxe-table-column
                        width="200"
                        field="skuQty"
                        :title="fieldMap.ptcSkuQty.displayName"
                        show-header-overflow="ellipsis" show-overflow="ellipsis"
                ></vxe-table-column>
            </vxe-table>
        </a-row>
    </div>
</template>
<script>
    import ajax from '../../../../api/ajax'
    import api from '../../../../api/url'
    export default{
        props :{
            uid: {
                type: String,
                required: true
            },
            fieldMap:{
                type: Object,
                required: true
            },
            btnFunArr:{
                type: Array,
                required: true
            }
        },
        data(){
            return{
                loadingCartontoCanTable: [],
                loadedCartonQtyNum: 0,
                form: this.$form.createForm(this),
                formItemLayout: {
                    labelCol: { span: 4 },
                    wrapperCol: { span: 8 },
                },
                tailFormItemLayout: {
                    labelCol: { span: 4 },
                    wrapperCol: { span: 8, offset: 4 },
                },
                pToCanContainerVal: this.fieldMap.ptcContainerNo.defaultVal,
                pToCanPalletVal: this.fieldMap.ptcPalletNo.defaultVal,
                removePalletConCked: false
            }
        },
        created() {
            this.init();
        },
        methods:{
            footerCellClassName ({ $rowIndex, column, columnIndex }) {
                return 'footerBackColor'
            },
            footerMethod({ columns, data }) {
                let that = this;
                return [
                    columns.map((column, columnIndex) => {
                        if (column.property == "sscc") {
                            return this.loadingCartontoCanTable.length;
                        }
                        if (
                            ['skuQty'].includes(
                                column.property
                            )
                        ) {
                            return that.sumPubFn(column.property);
                        }
                    })
                ];
            },
            sumPubFn(val) {
                let arr = this.loadingCartontoCanTable;
                var sum = 0;
                for (let index in arr) {
                    sum += arr[index][val];
                }
                return sum;
            },
            newContainer(){
                this.pToCanContainerVal = ''
                this.pToCanPalletVal = ''
            },
            pToCanContainerEnter(){
                this.$refs.palletNoTocRef.focus();
                this.loadingTable()
            },
            removePalletToConChange(){
                this.removePalletConCked = !this.removePalletConCked
            },
            pToCanPalletEnter(){
                let params = {
                    palletToContainer: {
                        containerNo: this.pToCanContainerVal,
                        palletNo: this.pToCanPalletVal
                    },
                    remove:this.removePalletConCked,
                    uid: this.uid
                }
                ajax.post(api.LOADINGSCAN,params).then(res=>{
                    if(res.code == 200){
                        this.pToCanPalletVal = ''
                        this.loadingTable()
                    }else{
                        this.$emit('subError', res.msg)
                    }
                })
            },
            loadingTable(){
                let params = {
                    uid: this.uid,
                    containerNo: this.pToCanContainerVal
                }
                ajax.get(api.LOADINGTABLE,params).then(res=>{
                    if(res.code == 200){
                        this.loadingCartontoCanTable = res.data
                        this.loadedCartonQtyNum = this.loadingCartontoCanTable.length
                    }
                })
            },
            init() {
                this.loadingTable();
            },
        }

    }
</script>